// sidebar but display the detail of an item

import { Type } from '@angular/core';
import { EntityId } from '../model';

export interface ISidebarDetail {

  // when detailData has been changed
  onInputChange(newInput: ISidebarDetailData): void;
}

// Whatever data need to pass into this detail sidebar will be put here for conventionally coding
export interface ISidebarDetailData {
  reconcileItemId?: EntityId;
}

export class SidebarDetailComponent {
  
  constructor(
    public detailComponent: Type<ISidebarDetail>,
  ) {}

}